import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import cartoon from '../../Assetes/Images/Delivery.png'
import Button from '@mui/material/Button';

import MenuBox from '../Menu/MenuBox';
import NewAddress from './NewAddress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import ReOrderCard from './ReOrderCard';
import { connect, useSelector } from 'react-redux';
import { lastFiveOrders } from '../../Redux/actions/menu';
import useTrackEvent from '../../hooks/useTrackHook';
import { saveCart } from '../../Redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import useCurrentLocale from '../../hooks/useLanguage';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
function ReOrder(props: any) {
    let token = localStorage.getItem("userToken")
    let history = useHistory();
    const lastFiveOrders = useSelector((state: any) => state.menu.lastFiveOrders);
    const [addEvent] = useTrackEvent();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const lang = useCurrentLocale();

    const handleShow = () => {
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
          'event': 'reorder_clicks'
        })
        if (token) {
            props.lastFiveOrders(setShow,history);
        } else {
            toast.error(`${t("PLEASELOGINFIRSTTOREORDER")}`, {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
            });
            history.push(`/${lang}/login`);
        }
    }
    const { t } = useTranslation();
    return (
        <div className='text-center order-history'>
            <Button onClick={() => {
                handleShow()
                addEvent({
                    category: "events",
                    events: "reOrder button"
                })
            }} className='text-center f-w-600 reorder-btn' variant="contained" color='error'>{t("REORDER")}</Button>

            <Modal size="lg" show={show} onHide={handleClose} centered>
                <div className='modal-design'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Header className='justify-content-center' closeButton>
                    <Modal.Title className='font-bold'>{t("YOURPREVIOUSORDERS")}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='w-100 delivery-order'>
                    <div className='container order-history profile-title  '>
                        <div className="row">
                            {
                                lastFiveOrders?.map((order: any, id: any) =>
                                    <div className='col-md-4' key={id}>
                                        <ReOrderCard order={order} getLastSelectedOrder={props.getLastSelectedOrder} saveCart={props.saveCart} />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </Modal.Body>


            </Modal>
        </div >
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        lastFiveOrders: function (setShow:any,history:any) {
            dispatch(lastFiveOrders(setShow,history));
        },
        saveCart: function (cart: any[]) {
            dispatch(saveCart(cart));
        }
    }
}
export default connect(null, mapDispatchToProps)(ReOrder);